<template>
    <div class="deviceEcharts">
        <div :class="classObject" v-for="(v, i) in paramsEcharts" :key="i">
            <DeviceEchartsItem :deviceId="deviceId" :id="i" :paramsEcharts="v" :timeValue="timeValue"
                :deviceName="deviceName" :deviceTypes="deviceTypes" :assetId="assetId"  :energyType="energyType"/>
        </div>
        <div v-if="paramsEcharts.length === 3" class="deviceEcharts-placesHolder"></div>
    </div>
</template>
<script>
const classNames = require('classnames')
import DeviceEchartsItem from './DeviceEchartsItem.vue';
import { matchingDHWEchartsParams } from "@/assets/js/utils";

export default {
    components: { DeviceEchartsItem },
    name: "DeviceEcharts",
    props: {
        deviceTypes: {
            type: String,
            default: '中央空调主机'
        },
        paramsSubType: {
            type: String,
            default: 'total'
        },
        timeValue: {
            type: Number,
            default: new Date().getTime(),
        },
        deviceId: {
            type: String,
            default: "",
        },
        deviceName: {
            type: String,
            default: "全部",
        },
        assetId: {
            type: String,
            default: "",
        },
        // gc - 燃气制热， ec - 电制热， ac - 空气源热泵制热
        energyType: {
            type: String,
            default: "ac",
        },
    },
    data() {
        return {

        }
    },
    computed: {
        paramsEcharts: function () {
            console.log("paramsEcharts------", this.deviceTypes, this.paramsSubType);
            return matchingDHWEchartsParams(this.deviceTypes, this.paramsSubType).map(item => {
                const { left = [], right = [] } = item
                return left.map(element => ({
                    value: element,
                    label: element,
                    children: right.length ? right.map(rightItem => ({
                        value: rightItem,
                        label: rightItem,
                    })) : null
                }));
            })
        },
        classObj: function () {
            return this.paramsEcharts.length === 1 ? { width: '100%', height: '100%' } : {}

        },
        classObject: function () {
            return classNames({
                'deviceEcharts-content': true,
                'only': this.paramsEcharts.length === 1
            })
        }
    },
    mounted() {

    },
}
</script>
<style  lang="scss" scoped>
.deviceEcharts {
    width: 100%;
    height: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
    align-items: flex-start;
    margin-top: 15px;

    &-content {
        width: 595px;
        height: 42%;
    }

    .only {
        width: 1255px;
        height: 540px;
    }

    &-placesHolder {
        width: 595px;
        height: 0;
    }
}
</style>